module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAVCAYAAABc6S4mAAAAAXNSR0IArs4c6QAAANxJREFUSEu9lbEKwjAQhr+AdeqsbyjSoS4OKtKhk4hzEd/ANxNnJ1uJpBQpaJpeQsx8ue/+n/s5hfDpnC2wAi40HFXFY6iFEvZH59yAOaCBiielOnO39fEBlMAeMH/rTsnGpkQOyEiZcAAWQNIqUZyoKX9BxABjhV4yY0oBZJ0Sq11egBZilCQUaNZDdnkDPhCHXUGAMXYFA5x2dcHZAak0E856zVX1guOs9yh4GYCJfjwFHlN9fRlc2VCAK3RBW9ROHisHUZPssqVvu9iiMbaEAXIi34M/XDTRTX4D55aIkeQk/G8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/right-huang.png
// module id = Tp9M
// module chunks = 1